import React, { useEffect, useRef } from "react"
import { useDraggable } from "react-use-draggable-scroll"
import * as style from "./TileSlider.module.scss"

const TileSlider = ({ children }) => {
  const ref = useRef()
  const { events } = useDraggable(ref)
  const indicatorElementRef = useRef()
  let visibleSlideIndex = 0

  useEffect(() => {
    const indicatorChildren = indicatorElementRef.current.childNodes
    if (indicatorChildren.length) {
      indicatorChildren[0].classList.add("slider-indicator-active")
    }
  })

  function isInViewport(element) {
    const rect = element.getBoundingClientRect()
    return (
      rect.top >= 0
            && rect.left >= 0
            && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
            && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }

  const handleScroll = (event) => {
    if (event.currentTarget.childNodes.length && window.innerWidth < 1200) {
      event.currentTarget.childNodes.forEach((element, index) => {
        if (isInViewport(event.currentTarget.childNodes[0])) {
          indicatorElementRef.current.childNodes.forEach((el, i) => {
            el.classList.remove("slider-indicator-active")
          })
          indicatorElementRef.current.childNodes[0].classList.add("slider-indicator-active")
        } else if (isInViewport(element)) {
          visibleSlideIndex = index
          indicatorElementRef.current.childNodes.forEach((el, i) => {
            if (i === visibleSlideIndex) {
              el.classList.add("slider-indicator-active")
            } else {
              el.classList.remove("slider-indicator-active")
            }
          })
        }
      })
    }
  }

  const slides = children !== undefined ? children.filter((child) => child !== "\n") : []
  return (
    <section className={style.tileSlider}>
      <div
        className={style.slider}
        {...events}
        ref={ref}
        onScroll={handleScroll}
      >
        {slides.map((i, el) => (
          <div
            className={style.slide}
            key={`${slides[el.key]}_${Math.random() * Math.random()}}`}
          >
            {slides[el]}
          </div>
        ))}
      </div>
      <div ref={indicatorElementRef} className={style.slideIndicators}>
        {slides.map((i, el) => (
          <div
            className={style.slideIndicator}
            key={`${slides[el.key]}_${Math.random() * Math.random()}}`}
          />
        ))}
      </div>
    </section>
  )
}

export default TileSlider
